var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPhotoAlternate(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.826-105.869q-33.49 0-56.637-22.981-23.146-22.98-23.146-56.237v-589.826q0-33.49 23.146-56.637 23.147-23.146 56.637-23.146h390.347v79.783H182.826v589.826h589.826v-389.912h79.218v389.912q0 33.257-23.277 56.237-23.278 22.981-55.941 22.981H182.826ZM704.239-618v-87.218h-87.5v-66.5h87.218v-88.066h66.5v87.501h87.5v66.783H770.74v87.5h-66.501Zm-466.5 336h480l-144-192-127 167-94-124-115 149Zm-54.913-492.913v589.826-589.826Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/add_photo_alternate-274fe061.svg";
export { SvgAddPhotoAlternate as ReactComponent };